// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rag-offcanvass{
    width: 700px !important;
    background: #fff;
}
.health-bar {
    display: flex;
    gap: 4px;
}

.health-block {
    width: 19px;
    height: 30px;
    border-radius: 3px;
}

.health-block.up {
    background-color: #22c55e;
}

.health-block.down {
    background-color: #ef4444;
}

.failure-table {
    border-top: 1px solid #eee;
}

.failure-header,
.failure-row {
    display: grid;
    grid-template-columns: 80px 1fr 140px;
    gap: 12px;
    padding: 8px 0;
    font-size: 13px;
}

.failure-header {
    font-weight: 600;
    color: #6c757d;
}

.failure-row {
    border-top: 1px solid #f1f1f1;
}

.badge.bg-orange {
    background-color: #f97316;
    /* orange */
    color: #fff;
}

.failure-status-badge {
    width: 48px;
    height: 24px;
    border-radius: 20px;

    display: inline-flex;
    align-items: center;
    justify-content: center;

    font-size: 12px;
    line-height: 1;

    white-space: nowrap;
    flex-shrink: 0;
}

.section-titles {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 8px;
}

.response_summary{
    max-width: 320px;
    white-space: normal;
    word-break: break-word;
    /* overflow-wrap: anywhere; */
    overflow-y: auto;
}`, "",{"version":3,"sources":["webpack://./src/components/HealthAnalytic/RightModelHealth.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;;IAEvB,eAAe;IACf,cAAc;;IAEd,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,6BAA6B;IAC7B,gBAAgB;AACpB","sourcesContent":[".rag-offcanvass{\n    width: 700px !important;\n    background: #fff;\n}\n.health-bar {\n    display: flex;\n    gap: 4px;\n}\n\n.health-block {\n    width: 19px;\n    height: 30px;\n    border-radius: 3px;\n}\n\n.health-block.up {\n    background-color: #22c55e;\n}\n\n.health-block.down {\n    background-color: #ef4444;\n}\n\n.failure-table {\n    border-top: 1px solid #eee;\n}\n\n.failure-header,\n.failure-row {\n    display: grid;\n    grid-template-columns: 80px 1fr 140px;\n    gap: 12px;\n    padding: 8px 0;\n    font-size: 13px;\n}\n\n.failure-header {\n    font-weight: 600;\n    color: #6c757d;\n}\n\n.failure-row {\n    border-top: 1px solid #f1f1f1;\n}\n\n.badge.bg-orange {\n    background-color: #f97316;\n    /* orange */\n    color: #fff;\n}\n\n.failure-status-badge {\n    width: 48px;\n    height: 24px;\n    border-radius: 20px;\n\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: 12px;\n    line-height: 1;\n\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.section-titles {\n    font-size: 14px;\n    font-weight: 400;\n    margin-bottom: 8px;\n}\n\n.response_summary{\n    max-width: 320px;\n    white-space: normal;\n    word-break: break-word;\n    /* overflow-wrap: anywhere; */\n    overflow-y: auto;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
